import {Component, Input} from '@angular/core';
import {CommonModule} from "@angular/common";
import {ItemModule} from "../../../../../core/component/item/item.module";
import {TagSummaryModel} from "../../model/tagSummary.model";
import {SummaryModule} from "../../../../../core/component/summary/summary.module";
import {MatTooltipModule} from "@angular/material/tooltip";
import {TagDeleteService} from "../../service/tagDelete.service";
import {DialogController} from "../../../../dialog/dialogController";
import {TagSaveDialogComponent, TagSaveDialogInput} from "../tag-save-dialog/tag-save-dialog.component";

@Component({
  selector: 'app-tag-item',
  templateUrl: './tag-item.component.html',
  standalone: true,
  imports: [
    CommonModule,
    ItemModule,
    SummaryModule,
    MatTooltipModule,
    TagSaveDialogComponent,
  ],
  providers: [
    TagDeleteService
  ]
})
export class TagItemComponent {
  @Input() entity: TagSummaryModel;

  constructor(public deleteService: TagDeleteService,
              private dialogController: DialogController) {

  }

  edit() {
    const input: TagSaveDialogInput = {
      id: this.entity.id
    }
    this.dialogController.open(TagSaveDialogComponent, input, {
      title: 'Modifier l\'étiquette',
      width: '400px'
    });
  }
}
